module.exports = __webpack_public_path__ + "media/images/application/template/tick-ec4f3e01c6ebcddbf003c53ffab69e0b.png";